(function () {
  var root = document.querySelector('[data-b2b-app]');
  if (!root) return;

  var form = root.querySelector('form');
  if (!form) return;

  var steps = Array.prototype.slice.call(root.querySelectorAll('[data-b2b-step]'));
  var indicators = Array.prototype.slice.call(root.querySelectorAll('[data-b2b-step-indicator]'));
  var reviewList = root.querySelector('[data-b2b-review]');
  var submitBtn = root.querySelector('[data-b2b-submit]');
  var submitLabel = root.querySelector('[data-b2b-submit-label]');
  var currentStep = 1;

  var VALIDATORS = {
    email: function (value) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    },
    phone: function (value) {
      var digits = value.replace(/[^\d]/g, '');
      return digits.length >= 8 && digits.length <= 15;
    },
    abn: function (value) {
      var digits = value.replace(/[^\d]/g, '');
      return digits.length === 11;
    }
  };

  function fieldsInStep(stepEl) {
    return Array.prototype.slice.call(
      stepEl.querySelectorAll('input[data-b2b-required], select[data-b2b-required], textarea[data-b2b-required]')
    );
  }

  function showError(input, message) {
    input.setAttribute('aria-invalid', 'true');
    var slot = root.querySelector('[data-b2b-error-for="' + input.id + '"]');
    if (slot) slot.textContent = message;
  }

  function clearError(input) {
    input.removeAttribute('aria-invalid');
    var slot = root.querySelector('[data-b2b-error-for="' + input.id + '"]');
    if (slot) slot.textContent = '';
  }

  function validateField(input) {
    var value = input.value.trim();

    if (input.hasAttribute('data-b2b-required') && !value) {
      showError(input, 'This field is required.');
      return false;
    }

    var type = input.getAttribute('data-b2b-type');
    if (type && value && VALIDATORS[type] && !VALIDATORS[type](value)) {
      var messages = {
        email: 'Enter a valid email address.',
        phone: 'Enter a valid phone number.',
        abn: 'ABN must be 11 digits.'
      };
      showError(input, messages[type] || 'This value looks incorrect.');
      return false;
    }

    clearError(input);
    return true;
  }

  function validateStep(stepNumber) {
    var stepEl = steps[stepNumber - 1];
    var fields = fieldsInStep(stepEl);
    var valid = true;
    var firstInvalid = null;

    fields.forEach(function (input) {
      var ok = validateField(input);
      if (!ok) {
        valid = false;
        if (!firstInvalid) firstInvalid = input;
      }
    });

    if (firstInvalid) firstInvalid.focus();
    return valid;
  }

  function goToStep(stepNumber, options) {
  options = options || {};

  steps.forEach(function (stepEl, index) {
    var isActive = index + 1 === stepNumber;
    stepEl.classList.toggle('is-active', isActive);
    stepEl.setAttribute('aria-hidden', String(!isActive));
  });

  indicators.forEach(function (li) {
    var n = parseInt(li.getAttribute('data-b2b-step-indicator'), 10);
    li.classList.toggle('is-active', n === stepNumber);
    li.classList.toggle('is-complete', n < stepNumber);
  });

  currentStep = stepNumber;

  if (stepNumber === 3) populateReview();

  if (!options.skipScroll) {
    var heading = root.querySelector('#b2b-app-heading');
    if (heading) {
      var headerOffset = 100; // высота sticky-хедера + отступ, подправьте под реальную высоту
      var elementPosition = heading.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top: elementPosition - headerOffset,
        behavior: 'smooth'
      });
    }
  }
}

  function populateReview() {
  if (!reviewList) return;
  reviewList.innerHTML = '';

  var reviewableFields = Array.prototype.slice.call(
    form.querySelectorAll('input[data-b2b-required], select[data-b2b-required]')
  );

  reviewableFields.forEach(function (input) {
    var labelEl = input.id ? root.querySelector('label[for="' + input.id + '"]') : null;
    var labelText = labelEl
      ? labelEl.textContent.trim()
      : (input.getAttribute('placeholder') || input.name);

    var value = input.tagName === 'SELECT'
      ? (input.options[input.selectedIndex] ? input.options[input.selectedIndex].text : '')
      : input.value;

    var row = document.createElement('div');
    row.className = 'b2b-app__review-row';

    var dt = document.createElement('dt');
    dt.textContent = labelText;

    var dd = document.createElement('dd');
    dd.textContent = value || '—';

    row.appendChild(dt);
    row.appendChild(dd);
    reviewList.appendChild(row);
  });
}

  root.addEventListener('click', function (event) {
    var nextBtn = event.target.closest('[data-b2b-next]');
    if (nextBtn) {
      event.preventDefault();
      if (validateStep(currentStep)) {
        goToStep(Math.min(currentStep + 1, steps.length));
      }
      return;
    }

    var backBtn = event.target.closest('[data-b2b-back]');
    if (backBtn) {
      event.preventDefault();
      goToStep(Math.max(currentStep - 1, 1));
    }
  });

  
  form.addEventListener('input', function (event) {
    var input = event.target;
    if (input.matches('input[data-b2b-required], select[data-b2b-required], textarea[data-b2b-required]')) {
      if (input.getAttribute('aria-invalid') === 'true') validateField(input);
    }
  });

  form.addEventListener('submit', function (event) {
   
    var allValid = true;
    for (var i = 1; i <= steps.length; i++) {
      if (!validateStep(i)) {
        allValid = false;
        goToStep(i);
        break;
      }
    }

    if (!allValid) {
      event.preventDefault();
      return;
    }

    
    var hp = form.querySelector('#b2b-hp-field');
    if (hp && hp.value) {
      event.preventDefault();
      return;
    }

    if (submitBtn) {
      submitBtn.setAttribute('disabled', 'disabled');
      if (submitLabel) submitLabel.textContent = 'Submitting…';
    }
   
  });

  goToStep(1, { skipScroll: true });
})();